module.exports = __webpack_public_path__ + "static/media/dashboard.21c0b5ba.svg";